import { render, staticRenderFns } from "./FideicomisoDetails.vue?vue&type=template&id=667220e8&scoped=true&"
import script from "./FideicomisoDetails.vue?vue&type=script&lang=js&"
export * from "./FideicomisoDetails.vue?vue&type=script&lang=js&"
import style0 from "./FideicomisoDetails.vue?vue&type=style&index=0&id=667220e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667220e8",
  null
  
)

export default component.exports